import { render, staticRenderFns } from "./ModalDepartment.vue?vue&type=template&id=0c768543&"
import script from "./ModalDepartment.vue?vue&type=script&lang=js&"
export * from "./ModalDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports